/**
 * Defines role-based access models and provides service functions for
 * retrieving user roles, permissions, and feature configurations from the backend.
 */
import { api } from "@/api";

export interface RoleFeature {
  feature_id: number;
  domain: string;
  feature_code: string;
  route_path: string | null;

  access_type: "DEFAULT" | "OPTIONAL";
  access: 0 | 1; // changed from boolean to 0|1 to match backend payload
  display_order: number;

  feature_type?: string;
  source_type?: string;
  display_name?: string;

  title_key?: string;
  subtitle_key?: string;

  icon_name?: string;
  widget_component?: string;

  layout?: string;
  mobile_visible?: boolean;
  tablet_visible?: boolean;
}

export interface UserFeaturesResponse {
  userPrincipalName: string;
  roleCodes: string[];
  features: RoleFeature[];
}

export const getUserFeatures = (email: string) => {
  return api.getUserFeatures(email);
};

export const getUserDetails = (email: string) => {
  return api.getUserDetails(email);
};
